import { truncateText } from '../../utilities';
import styles from './bar-label.module.css';

type BarLabelProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  fontSize?: number;
  label: string;
  textAnchor?: 'start' | 'middle';
  /** Ellipsis width budget; defaults to `width` (bar slot). Use when the slot is narrow but text should stay readable. */
  truncateMaxWidth?: number;
};

export const BarLabel = ({
  x,
  y,
  width,
  height,
  fontSize = 11,
  label,
  textAnchor = 'start',
  truncateMaxWidth,
}: BarLabelProps) => {
  const truncatedLabel = truncateText({
    text: label,
    maxWidth: truncateMaxWidth ?? width,
    fontSize,
  });

  const textX = textAnchor === 'middle' ? x + width / 2 : x;

  return (
    <text
      x={textX}
      y={y + height / 2}
      textAnchor={textAnchor}
      dy="0.25em"
      fontSize={`${fontSize}px`}
      className={styles.barLabel}
      data-testid="bar-chart__bar-label"
    >
      <title>{label}</title>
      {truncatedLabel}
    </text>
  );
};
